import { DateTimeUtils } from '@common/utils';
import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { HospitalScheduleDayEntityModel } from './HospitalScheduleDayEntityModel';

/**
 * This is a wrapper for a single schedule day.  Instead of a record for each vet/template for each day, the new schedule end point returns 1 schedule for each day in the requested range, and the scheduled entities for that day
 * and each of those scheduled entities could be a template or a vet and can have computed schedule preferences.
 * This will be for a hospitalId requested to the new schedule end point and the open/close time of that hospital for the day on this model is included.
 */
export class HospitalScheduleDayModel {
  hospitalId: number;
  day: DateTime;
  openTime: string;
  closeTime: string;
  isOpen: boolean;
  scheduledEntities: HospitalScheduleDayEntityModel[];

  constructor(init?: Partial<HospitalScheduleDayModel>) {
    this.hospitalId = defaultTo(init?.hospitalId, 0);
    this.day = DateTimeUtils.getAsDateTimeUTC(init?.day ?? DateTime.utc())!;
    this.openTime = defaultTo(init?.openTime, '08:00:00');
    this.closeTime = defaultTo(init?.closeTime, '21:00:00');
    this.isOpen = defaultTo(init?.isOpen, false);
    this.scheduledEntities =
      init?.scheduledEntities?.map(
        (e) => new HospitalScheduleDayEntityModel(e),
      ) ?? ([] as HospitalScheduleDayEntityModel[]);
  }
}
